// extracted by mini-css-extract-plugin
module.exports = {"spinner":"HarvestsPdf_spinner__3y6oG","container":"HarvestsPdf_container__2E_dQ","body":"HarvestsPdf_body__dZU4L","harvestHistogram":"HarvestsPdf_harvestHistogram__3io_-"};